import authRules from '../authRules.js';

const addAssignmentViewSalaryLevel = (user) => {
  const { rsSalaryLevel } = user.securityLevels;
  if (rsSalaryLevel >= authRules.addAssignmentViewSalaryLevel.rsSalaryLevel) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentViewSalaryLevel;
